import * as React from 'react';
import {
  AlarmLargeIcon,
  AlarmIcon,
  AppleIcon,
  ArrowDownIcon,
  ArrowLeftLargeIcon,
  ArrowLeftIcon,
  ArrowUpIcon,
  CheckmarkIcon,
  ControlsIcon,
  DotsHorizontalIcon,
  EyeLargeIcon,
  EyeIcon,
  FacebookLargeIcon,
  FacebookIcon,
  GlobeIcon,
  GoogleIcon,
  HideIcon,
  LinkIcon,
  LockIcon,
  LogoLargeBlackIcon,
  LogoLargeIcon,
  LogoMediumOutlinedIcon,
  LogoMediumIcon,
  LogoSmallIcon,
  PenIcon,
  PlusExtraLargeIcon,
  PlusLargeIcon,
  PollIcon,
  UndoIcon,
  RedoIcon,
  ShareIcon,
  SortLargeIcon,
  SortIcon,
  TimesLargeIcon,
  TimesIcon,
  TrashLargeBlackIcon,
  TrashIcon,
  UserAddLargeIcon,
  UserAddIcon,
  UserIcon,
  UserCircleIcon,
  UsersMoreIcon,
  UsersIcon,
  ZoomIcon,
  PlayIcon,
  HamburgerIcon,
  SettingsIcon,
  LogoutIcon,
  NoPhotoIcon,
  NotSupportedIcon,
  PenIconFilled,
  TrashIconFilled,
  ShareIconFilled,
  FolderIconFilled,
  PenIconFilledBlack,
} from 'shared/components/Icons';

import Logo from 'assets/images/logo.png';
import NoResults from 'assets/images/illustrations/no-results.svg';
import NotFound from 'assets/images/illustrations/not-found.svg';
import AddProject from 'assets/images/illustrations/add-project.svg';
import NoImage from 'assets/images/illustrations/no-image.svg';
import Settings from 'assets/images/illustrations/settings.svg';
import Message from 'assets/images/illustrations/messge.svg';
import Heart from 'assets/images/illustrations/heart.svg';
import Phone from 'assets/images/illustrations/phone.svg';

const Iconography = () => {
  return (
    <div>
      <AlarmLargeIcon />
      <AlarmIcon />
      <AppleIcon />
      <ArrowDownIcon />
      <ArrowLeftLargeIcon />
      <ArrowLeftIcon />
      <ArrowUpIcon />
      <CheckmarkIcon />
      <ControlsIcon />
      <DotsHorizontalIcon />
      <EyeLargeIcon />
      <EyeIcon />
      <FacebookLargeIcon />
      <FacebookIcon />
      <GlobeIcon />
      <GoogleIcon />
      <HideIcon />
      <LinkIcon />
      <LockIcon />
      <LogoLargeBlackIcon />
      <LogoLargeIcon />
      <LogoMediumOutlinedIcon />
      <LogoMediumIcon />
      <LogoSmallIcon />
      <PenIcon />
      <PlusExtraLargeIcon />
      <PlusLargeIcon />
      <UndoIcon />
      <RedoIcon />
      <ShareIcon />
      <SortLargeIcon />
      <SortIcon />
      <TimesLargeIcon />
      <TimesIcon />
      <TrashLargeBlackIcon />
      <TrashIcon />
      <UserAddLargeIcon />
      <UserAddIcon />
      <UsersMoreIcon />
      <UsersIcon />
      <ZoomIcon />
      <PlayIcon />
      <HamburgerIcon />
      <PollIcon />
      <UserIcon />
      <UserCircleIcon />
      <SettingsIcon />
      <LogoutIcon />
      <NoPhotoIcon />
      <NotSupportedIcon />
      <span className='bg-gray p-3'>
        <PenIconFilled />
      </span>
      <span className='bg-gray p-3'>
        <TrashIconFilled />
      </span>
      <span className='bg-gray p-3'>
        <ShareIconFilled />
      </span>
      <span className='bg-gray p-3'>
        <FolderIconFilled />
      </span>
      <PenIconFilledBlack />
      <br />
      <br />
      <br />
      <img src={Logo} alt='Logo' title='Logo' className='mr-50 mb-20' />
      <img src={NoResults} alt='NoResults' title='NoResults' className='mr-50 mb-20' />
      <img src={NotFound} alt='NotFound' title='NotFound' className='mr-50 mb-20' />
      <img src={AddProject} alt='AddProject' title='AddProject' className='mr-50 mb-20' />
      <img src={NoImage} alt='NoImage' title='NoImage' className='mr-50 mb-20' />
      <img src={Settings} alt='Settings' title='Settings' className='mr-50 mb-20' />
      <img src={Message} alt='Message' title='Message' className='mr-50 mb-20' />
      <img src={Heart} alt='Heart' title='Heart' className='mr-50 mb-20' />
      <img src={Phone} alt='Phone' title='Phone' className='mr-50 mb-20' />
    </div>
  );
};

export default Iconography;
